import axios from 'axios';
import { useShopStore } from '@/stores/shop.store';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class KDSRegistersApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/kds-registers' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async stations(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/kds-registers/' + id + '/stations' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// ปิดออเดอร์ที่ค้างบนจอครัวของสาขานี้ทั้งหมด (ปุ่มล้างของค้างในตาราง KDS)
	async completePendingOrders(id) {
		try {
			const response = await axios.put(BASE_URI + '/v1/kds-registers/' + id + '/orders/complete' + signature(), {}, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async enterKds(id, stationId = null) {
		try {
			// ไม่ส่ง stationId = ทุกหมวด (All)
			const queryString = stationId ? '?station_id=' + stationId : '';
			const response = await axios.get(BASE_URI + '/v1/kds-registers/' + id + '/kds' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const KDSRegisters = new KDSRegistersApi();
